import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 6BF9FB77-DF50-40B5-9A93-43E2A22E8633
 * name store-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-outline.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const StoreOutlineIcon = createSvgIcon(<><path d="M18.36 9L18.96 12H5.04L5.64 9H18.36M20 4H4V6H20V4M20 7H4L3 12V14H4V20H14V14H18V20H20V14H21V12L20 7M6 18V14H12V18H6Z" /></>, 'StoreOutlineIcon');
export default StoreOutlineIcon